'use client'

import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface DataFetchErrorProps {
  title: string
  message?: string
  errorDetails?: string
  used?: string
  children?: React.ReactNode
}

export default function DataFetchError({
  title,
  message,
  errorDetails,
  used,
  children,
}: DataFetchErrorProps) {
  return (
    <div className={clsx(styles.container, used && styles[used])}>
      <h1 className={styles.title}>{title}</h1>
      {message && <p className={styles.text}>{message}</p>}
      {errorDetails && <p className={styles.message}>{errorDetails}</p>}
      {children}
    </div>
  )
}
